import { StartHandoverScreen } from "~/session/start-handover/start-handover-screen";

// /session/:id/start-handover — the outgoing doctor confirms, then generates and
// sees the one-time handover code (E6.4). Access is limited to the session's
// outgoing doctor on a draft session with at least one patient; the shared screen
// resolves that and renders the confirmation, code display, or the right gate
// state. It renders inside <SessionLayout>, which provides the session via context.
export default function StartHandoverRoute(): JSX.Element {
  return <StartHandoverScreen />;
}
